import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { AuthorizationModule } from '@wilson/authorization';
import { FeatureFlagsModule } from '@wilson/feature-flags';
import { UserTimelines } from '@wilson/interfaces';
import {
  SharedComponentsModule,
  UserDetailsModule,
} from '@wilson/shared-components';
import { TimelineInteractionService } from '@wilson/shift-timeline/services';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';

@Component({
  selector: 'wilson-timeline-user-details',
  templateUrl: './timeline-user-details.component.html',
  styleUrls: ['./timeline-user-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    SharedComponentsModule,
    NzTooltipModule,
    NzSkeletonModule,
    UserDetailsModule,
    AuthorizationModule,
    FeatureFlagsModule,
    NzDividerModule,
  ],
})
export class TimelineUserDetailsComponent {
  timelineInteractionService = inject(TimelineInteractionService);

  @Input({ required: true }) user: UserTimelines | null = null;
  @Input() smallText = false;
}
